// Nederlandse steden GPS coordinaten
export const DUTCH_CITIES_COORDINATES = {
  "Aalsmeer": { "lat": 52.2592, "lng": 4.7597 },
  "Aalten": { "lat": 51.9267, "lng": 6.5807 },
  "Achterhoek": { "lat": 52.0026, "lng": 6.3914 },
  "Alblasserdam": { "lat": 51.8703, "lng": 4.6702 },
  "Alkmaar": { "lat": 52.6324, "lng": 4.7534 },
  "Almelo": { "lat": 52.3567, "lng": 6.6625 },
  "Almere": { "lat": 52.3714, "lng": 5.2221 },
  "Alphen aan den Rijn": { "lat": 52.1293, "lng": 4.6555 },
  "Amersfoort": { "lat": 52.1551, "lng": 5.3872 },
  "Amstelveen": { "lat": 52.3114, "lng": 4.8701 },
  "Amsterdam": { "lat": 52.3740, "lng": 4.8897 },
  "Anna Paulowna": { "lat": 52.8616, "lng": 4.8238 },
  "Apeldoorn": { "lat": 52.2112, "lng": 5.9699 },
  "Arnhem": { "lat": 51.9851, "lng": 5.8987 },
  "Assen": { "lat": 52.9967, "lng": 6.5625 },
  "Assendelft": { "lat": 52.4871, "lng": 4.7561 },
  "Asten": { "lat": 51.4042, "lng": 5.7486 },
  "Baarn": { "lat": 52.2132, "lng": 5.2864 },
  "Badhoevedorp": { "lat": 52.3381, "lng": 4.7803 },
  "Barendrecht": { "lat": 51.8567, "lng": 4.5347 },
  "Barneveld": { "lat": 52.1402, "lng": 5.5842 },
  "Bergeijk": { "lat": 51.3192, "lng": 5.3583 },
  "Bergen": { "lat": 52.6733, "lng": 4.7070 },
  "Bergen op Zoom": { "lat": 51.4946, "lng": 4.2872 },
  "Berkel en Rodenrijs": { "lat": 51.9914, "lng": 4.4733 },
  "Best": { "lat": 51.5075, "lng": 5.3903 },
  "Beuningen": { "lat": 51.8597, "lng": 5.7691 },
  "Beverwijk": { "lat": 52.4870, "lng": 4.6574 },
  "Bilthoven": { "lat": 52.1333, "lng": 5.2000 },
  "Bladel": { "lat": 51.3630, "lng": 5.2136 },
  "Bodegraven": { "lat": 52.0823, "lng": 4.7461 },
  "Borne": { "lat": 52.3002, "lng": 6.7537 },
  "Boxmeer": { "lat": 51.6479, "lng": 5.9470 },
  "Boxtel": { "lat": 51.5907, "lng": 5.3260 },
  "Breda": { "lat": 51.5866, "lng": 4.7760 },
  "Brunssum": { "lat": 50.9489, "lng": 5.9722 },
  "Bussum": { "lat": 52.2833, "lng": 5.1667 },
  "Capelle aan den IJssel": { "lat": 51.9302, "lng": 4.5777 },
  "Castricum": { "lat": 52.5453, "lng": 4.6727 },
  "Coevorden": { "lat": 52.6610, "lng": 6.7405 },
  "Cuijk": { "lat": 51.7308, "lng": 5.8792 },
  "Culemborg": { "lat": 51.9561, "lng": 5.2400 },
  "Dalfsen": { "lat": 52.5113, "lng": 6.2539 },
  "Delft": { "lat": 52.0112, "lng": 4.3571 },
  "Den Bosch": { "lat": 51.6978, "lng": 5.3037 },
  "Den Haag": { "lat": 52.0787, "lng": 4.2888 },
  "Den Helder": { "lat": 52.9563, "lng": 4.7608 },
  "Deurne": { "lat": 51.4614, "lng": 5.7908 },
  "Deventer": { "lat": 52.2661, "lng": 6.1552 },
  "Diemen": { "lat": 52.3396, "lng": 4.9626 },
  "Dieren": { "lat": 52.0527, "lng": 6.0956 },
  "Doetinchem": { "lat": 51.9647, "lng": 6.2938 },
  "Dokkum": { "lat": 53.3223, "lng": 5.9970 },
  "Dongen": { "lat": 51.6267, "lng": 4.9389 },
  "Doorn": { "lat": 52.0390, "lng": 5.3370 },
  "Dordrecht": { "lat": 51.8133, "lng": 4.6901 },
  "Drachten": { "lat": 53.1125, "lng": 6.0989 },
  "Drenthe": { "lat": 52.9928, "lng": 6.5642 },
  "Dronten": { "lat": 52.5347, "lng": 5.7218 },
  "Drunen": { "lat": 51.6869, "lng": 5.1378 },
  "Duiven": { "lat": 51.9475, "lng": 6.0179 },
  "Echt": { "lat": 51.1035, "lng": 5.8746 },
  "Ede": { "lat": 52.0402, "lng": 5.6649 },
  "Eindhoven": { "lat": 51.4416, "lng": 5.4697 },
  "Elburg": { "lat": 52.4493, "lng": 5.8345 },
  "Elst": { "lat": 51.9193, "lng": 5.8474 },
  "Emmeloord": { "lat": 52.7121, "lng": 5.7550 },
  "Emmen": { "lat": 52.7858, "lng": 6.8976 },
  "Enkhuizen": { "lat": 52.7154, "lng": 5.2847 },
  "Enschede": { "lat": 52.2215, "lng": 6.8937 },
  "Epe": { "lat": 52.3450, "lng": 5.9837 },
  "Ermelo": { "lat": 52.2987, "lng": 5.6296 },
  "Etten-Leur": { "lat": 51.5692, "lng": 4.6361 },
  "Friesland": { "lat": 53.2012, "lng": 5.7999 },
  "Gelderland": { "lat": 51.9851, "lng": 5.8987 },
  "Geldrop": { "lat": 51.4229, "lng": 5.5571 },
  "Geleen": { "lat": 50.9672, "lng": 5.8277 },
  "Gemert": { "lat": 51.5553, "lng": 5.6904 },
  "Goes": { "lat": 51.5046, "lng": 3.8911 },
  "Goirle": { "lat": 51.5237, "lng": 5.0642 },
  "Gorinchem": { "lat": 51.8372, "lng": 4.9758 },
  "Gouda": { "lat": 52.0115, "lng": 4.7105 },
  "Groesbeek": { "lat": 51.7784, "lng": 5.9348 },
  "Groningen": { "lat": 53.2194, "lng": 6.5665 },
  "Haaksbergen": { "lat": 52.1607, "lng": 6.7381 },
  "Haarlem": { "lat": 52.3874, "lng": 4.6462 },
  "Haarlemmermeer": { "lat": 52.3061, "lng": 4.6907 },
  "Hardenberg": { "lat": 52.5758, "lng": 6.6194 },
  "Harderwijk": { "lat": 52.3422, "lng": 5.6367 },
  "Heemskerk": { "lat": 52.5141, "lng": 4.6821 },
  "Heemstede": { "lat": 52.3511, "lng": 4.6203 },
  "Heerenveen": { "lat": 52.9606, "lng": 5.9205 },
  "Heerhugowaard": { "lat": 52.6714, "lng": 4.8486 },
  "Heerlen": { "lat": 50.8882, "lng": 5.9795 },
  "Heesch": { "lat": 51.7317, "lng": 5.5278 },
  "Heeze": { "lat": 51.3828, "lng": 5.5722 },
  "Heiloo": { "lat": 52.6029, "lng": 4.6871 },
  "Hellevoetsluis": { "lat": 51.8319, "lng": 4.1318 },
  "Helmond": { "lat": 51.4793, "lng": 5.6570 },
  "Hendrik-Ido-Ambacht": { "lat": 51.8424, "lng": 4.6395 },
  "Hengelo": { "lat": 52.2658, "lng": 6.7931 },
  "Hillegom": { "lat": 52.2908, "lng": 4.5833 },
  "Hilversum": { "lat": 52.2233, "lng": 5.1764 },
  "Hoensbroek": { "lat": 50.9239, "lng": 5.9253 },
  "Hoofddorp": { "lat": 52.3025, "lng": 4.6889 },
  "Hoogeveen": { "lat": 52.7225, "lng": 6.4764 },
  "Hoogezand": { "lat": 53.1635, "lng": 6.7563 },
  "Hoorn": { "lat": 52.6425, "lng": 5.0597 },
  "Horst": { "lat": 51.4504, "lng": 6.0515 },
  "Houten": { "lat": 52.0283, "lng": 5.1681 },
  "Huissen": { "lat": 51.9357, "lng": 5.9343 },
  "Huizen": { "lat": 52.2992, "lng": 5.2417 },
  "IJmuiden": { "lat": 52.4586, "lng": 4.6194 },
  "IJsselstein": { "lat": 52.0178, "lng": 5.0403 },
  "Kaatsheuvel": { "lat": 51.6571, "lng": 5.0306 },
  "Kampen": { "lat": 52.5580, "lng": 5.9145 },
  "Katwijk": { "lat": 52.2005, "lng": 4.4146 },
  "Kerkrade": { "lat": 50.8659, "lng": 6.0705 },
  "Krimpen aan den IJssel": { "lat": 51.9144, "lng": 4.5962 },
  "Landgraaf": { "lat": 50.8928, "lng": 6.0224 },
  "Landsmeer": { "lat": 52.4296, "lng": 4.9138 },
  "Leerdam": { "lat": 51.8943, "lng": 5.0969 },
  "Leeuwarden": { "lat": 53.2012, "lng": 5.7999 },
  "Leiden": { "lat": 52.1601, "lng": 4.4970 },
  "Leiderdorp": { "lat": 52.1510, "lng": 4.5282 },
  "Leidschendam": { "lat": 52.0798, "lng": 4.3996 },
  "Lelystad": { "lat": 52.5185, "lng": 5.4714 },
  "Lemmer": { "lat": 52.8449, "lng": 5.7106 },
  "Leusden": { "lat": 52.1325, "lng": 5.4319 },
  "Lisse": { "lat": 52.2579, "lng": 4.5575 },
  "Lochem": { "lat": 52.1614, "lng": 6.4156 },
  "Losser": { "lat": 52.2634, "lng": 7.0035 },
  "Maarssen": { "lat": 52.1363, "lng": 5.0339 },
  "Maassluis": { "lat": 51.9226, "lng": 4.2546 },
  "Maastricht": { "lat": 50.8514, "lng": 5.6910 },
  "Meppel": { "lat": 52.6925, "lng": 6.1909 },
  "Middelburg": { "lat": 51.5000, "lng": 3.6139 },
  "Mierlo": { "lat": 51.4411, "lng": 5.6165 },
  "Mijdrecht": { "lat": 52.2050, "lng": 4.8809 },
  "Moerdijk": { "lat": 51.7018, "lng": 4.6273 },
  "Naarden": { "lat": 52.2924, "lng": 5.1574 },
  "Nieuw-Vennep": { "lat": 52.2644, "lng": 4.6347 },
  "Nieuwegein": { "lat": 52.0248, "lng": 5.0918 },
  "Nederland": { "lat": 52.1814, "lng": 4.7666 }, // Centraal punt tussen Den Haag, Utrecht en Amsterdam
  "Nieuwerkerk aan den IJssel": { "lat": 51.9675, "lng": 4.6117 },
  "Nijkerk": { "lat": 52.2225, "lng": 5.4836 },
  "Nijmegen": { "lat": 51.8426, "lng": 5.8390 },
  "Nijverdal": { "lat": 52.3639, "lng": 6.4628 },
  "Noordwijk": { "lat": 52.2400, "lng": 4.4500 },
  "Nuenen": { "lat": 51.4700, "lng": 5.5478 },
  "Nunspeet": { "lat": 52.3792, "lng": 5.7861 },
  "Oegstgeest": { "lat": 52.1801, "lng": 4.4716 },
  "Oirschot": { "lat": 51.5070, "lng": 5.3092 },
  "Oisterwijk": { "lat": 51.5654, "lng": 5.2030 },
  "Oldebroek": { "lat": 52.4474, "lng": 5.8983 },
  "Oldenzaal": { "lat": 52.3117, "lng": 6.9268 },
  "Oosterhout": { "lat": 51.6410, "lng": 4.8617 },
  "Oss": { "lat": 51.7650, "lng": 5.5181 },
  "Oud-Beijerland": { "lat": 51.8189, "lng": 4.4272 },
  "Panningen": { "lat": 51.3289, "lng": 5.9794 },
  "Papendrecht": { "lat": 51.8425, "lng": 4.6942 },
  "Pijnacker": { "lat": 52.0194, "lng": 4.4320 },
  "Purmerend": { "lat": 52.5144, "lng": 4.9641 },
  "Putten": { "lat": 52.2587, "lng": 5.6054 },
  "Raalte": { "lat": 52.3799, "lng": 6.2862 },
  "Renkum": { "lat": 51.9835, "lng": 5.7421 },
  "Reuver": { "lat": 51.2862, "lng": 6.0828 },
  "Rhenen": { "lat": 51.9621, "lng": 5.5711 },
  "Ridderkerk": { "lat": 51.8703, "lng": 4.6022 },
  "Rijen": { "lat": 51.5910, "lng": 4.9181 },
  "Rijssen": { "lat": 52.3082, "lng": 6.5213 },
  "Rijswijk": { "lat": 52.0377, "lng": 4.3220 },
  "Roden": { "lat": 53.1384, "lng": 6.4324 },
  "Roermond": { "lat": 51.1913, "lng": 5.9878 },
  "Roosendaal": { "lat": 51.5358, "lng": 4.4653 },
  "Rosmalen": { "lat": 51.7167, "lng": 5.3653 },
  "Rotterdam": { "lat": 51.9244, "lng": 4.4777 },
  "Rucphen": { "lat": 51.5336, "lng": 4.5603 },
  "s-Hertogenbosch": { "lat": 51.6889, "lng": 5.3031 },
  "Schagen": { "lat": 52.7881, "lng": 4.8044 },
  "Schiedam": { "lat": 51.9170, "lng": 4.3988 },
  "Schijndel": { "lat": 51.6197, "lng": 5.4335 },
  "Schoonhoven": { "lat": 51.9525, "lng": 4.8432 },
  "Sint-Oedenrode": { "lat": 51.5655, "lng": 5.4620 },
  "Sittard": { "lat": 50.9983, "lng": 5.8694 },
  "Sittard-Geleen": { "lat": 51.0094, "lng": 5.8376 },
  "Sliedrecht": { "lat": 51.8249, "lng": 4.7732 },
  "Sneek": { "lat": 53.0337, "lng": 5.6556 },
  "Soest": { "lat": 52.1764, "lng": 5.2992 },
  "Someren": { "lat": 51.3850, "lng": 5.7124 },
  "Son en Breugel": { "lat": 51.5110, "lng": 5.4936 },
  "Spijkenisse": { "lat": 51.8562, "lng": 4.2972 },
  "Stadskanaal": { "lat": 52.9920, "lng": 6.9462 },
  "Steenwijk": { "lat": 52.7869, "lng": 6.1181 },
  "Steenwijkerland": { "lat": 52.7478, "lng": 6.0232 },
  "Stein": { "lat": 50.9680, "lng": 5.7662 },
  "Stolwijk": { "lat": 51.9737, "lng": 4.7721 },
  "t Harde": { "lat": 52.4154, "lng": 5.8840 },
  "Tegelen": { "lat": 51.3437, "lng": 6.1374 },
  "Terneuzen": { "lat": 51.3323, "lng": 3.8324 },
  "Tiel": { "lat": 51.8876, "lng": 5.4279 },
  "Tilburg": { "lat": 51.5606, "lng": 5.0919 },
  "Twello": { "lat": 52.2367, "lng": 6.1028 },
  "Twente": { "lat": 52.3197, "lng": 6.7688 },
  "Uden": { "lat": 51.6608, "lng": 5.6194 },
  "Uithoorn": { "lat": 52.2446, "lng": 4.8317 },
  "Urk": { "lat": 52.6631, "lng": 5.6014 },
  "Utrecht": { "lat": 52.0907, "lng": 5.1214 },
  "Valkenswaard": { "lat": 51.3508, "lng": 5.4597 },
  "Veendam": { "lat": 53.1063, "lng": 6.8751 },
  "Veenendaal": { "lat": 52.0286, "lng": 5.5589 },
  "Veghel": { "lat": 51.6158, "lng": 5.5392 },
  "Veldhoven": { "lat": 51.4183, "lng": 5.4028 },
  "Velp": { "lat": 51.9950, "lng": 5.9736 },
  "Venlo": { "lat": 51.3704, "lng": 6.1724 },
  "Venray": { "lat": 51.5250, "lng": 5.9750 },
  "Vianen": { "lat": 51.9925, "lng": 5.0917 },
  "Vlaardingen": { "lat": 51.9121, "lng": 4.3494 },
  "Vleuten": { "lat": 52.1074, "lng": 5.0135 },
  "Vlijmen": { "lat": 51.7000, "lng": 5.2333 },
  "Vlissingen": { "lat": 51.4425, "lng": 3.5736 },
  "Volendam": { "lat": 52.4969, "lng": 5.0727 },
  "Voorburg": { "lat": 52.0742, "lng": 4.3597 },
  "Voorschoten": { "lat": 52.1275, "lng": 4.4486 },
  "Vught": { "lat": 51.6542, "lng": 5.2872 },
  "Waalre": { "lat": 51.3867, "lng": 5.4444 },
  "Waalwijk": { "lat": 51.6825, "lng": 5.0708 },
  "Waddinxveen": { "lat": 52.0313, "lng": 4.6591 },
  "Wageningen": { "lat": 51.9700, "lng": 5.6667 },
  "Wassenaar": { "lat": 52.1432, "lng": 4.3949 },
  "Weert": { "lat": 51.2517, "lng": 5.7069 },
  "Weesp": { "lat": 52.3075, "lng": 5.0417 },
  "Werkendam": { "lat": 51.8100, "lng": 4.8944 },
  "Westervoort": { "lat": 51.9638, "lng": 5.9690 },
  "Westland": { "lat": 52.0007, "lng": 4.2111 },
  "Wijchen": { "lat": 51.8092, "lng": 5.7250 },
  "Wijk bij Duurstede": { "lat": 51.9756, "lng": 5.3384 },
  "Winschoten": { "lat": 53.1442, "lng": 7.0347 },
  "Winterswijk": { "lat": 51.9725, "lng": 6.7194 },
  "Woerden": { "lat": 52.0869, "lng": 4.8913 },
  "Wolvega": { "lat": 52.8766, "lng": 5.9959 },
  "Zaandam": { "lat": 52.4420, "lng": 4.8292 },
  "Zaanstad": { "lat": 52.4531, "lng": 4.8136 },
  "Zandvoort": { "lat": 52.3713, "lng": 4.5308 },
  "Zeeland": { "lat": 51.5670, "lng": 3.7500 },
  "Zeewolde": { "lat": 52.3300, "lng": 5.5417 },
  "Zeist": { "lat": 52.0900, "lng": 5.2333 },
  "Zevenaar": { "lat": 51.9333, "lng": 6.0843 },
  "Zoetermeer": { "lat": 52.0575, "lng": 4.4931 },
  "Zundert": { "lat": 51.4717, "lng": 4.6556 },
  "Zutphen": { "lat": 52.1383, "lng": 6.2014 },
  "Zwijndrecht": { "lat": 51.8175, "lng": 4.6333 },
  "Zwolle": { "lat": 52.5125, "lng": 6.0944 }
};

// Nederland center en bounds voor Leaflet
export const NETHERLANDS_CENTER = [52.1326, 5.2913];
export const NETHERLANDS_BOUNDS = [
  [50.7, 3.3], // Southwest
  [53.6, 7.2]  // Northeast
];
